<template>
  <div id="app">
    <v-header />
    <div class="container">
      <v-menus class="aside-menu"></v-menus>
      <v-content />
    </div>
  </div>
</template>

<script>
import vHeader from "./components/header";
import vMenus from "./components/menus";
import vContent from "./components/content";

export default {
  name: "Layout",

  components: {
    vHeader,
    vMenus,
    vContent
  },

  data() {
    return {
      route: {} //当前路由
    };
  }
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  max-width: 1400px;
  min-width: 1200px;
  overflow: hidden;
  position: absolute;
  left: 50%;
  top: 88px;
  bottom: 24px;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  transform: translateX(-50%);
}
</style>
